import React from 'react';
import SchemaReference from './SchemaReference';
import ChatPanel from './ChatPanel';

const SchemaChatSplit = ({
  schema,
  pinnedNow,
  chatMessages,
  onSendMessage,
  onAskLLM,
  onClearChat,
  chatLoading,
  chatOpen,
  onChatToggle
}) => {
  return (
    <div className={`sql-trainer-schema-chat-split ${chatOpen ? 'chat-open' : 'chat-closed'}`}>
      <div className="schema-chat-split-schema">
        <SchemaReference
          schema={schema}
          pinnedNow={pinnedNow}
          alwaysOpen={true}
        />
      </div>

      <div className={`schema-chat-split-chat ${chatOpen ? 'open' : ''}`}>
        <ChatPanel
          messages={chatMessages}
          onSendMessage={onSendMessage}
          onAskLLM={onAskLLM}
          onClearChat={onClearChat}
          isLoading={chatLoading}
          isOpen={chatOpen}
          onToggle={onChatToggle}
        />
      </div>
    </div>
  );
};

export default SchemaChatSplit;
